module.exports = __webpack_public_path__ + "static/media/condenser-04.cf98ca64.png";